export default __webpack_public_path__ + "static/media/mail.beb4a25a.svg";